import React, { useState, useRef, useEffect } from 'react'
import { NumericFormat } from 'react-number-format';
import BotonesPos from './pasarelaPago/BotonesPos'
import Billetes from './pasarelaPago/Billetes'
import Domicilios from './pasarelaPago/Domicilios'
import ModalPagoFinal from './pasarelaPago/modalPagoFinal/MediosDePago'
import RegistraClientes from './pasarelaPago/RegistraClientes'
import FacturaElectronica from './pasarelaPago/FacturaElectronica'
import { MDBInput } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartArrowDown, faCreditCard, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons'
import Tiquete from './pasarelaPago/Tiquete'
import moment from 'moment'
import axios from 'axios'
import Cookies from 'universal-cookie'

const currencyFormat = (num) => {
	let convert = parseFloat(num)
	return '$' + convert.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}


const PasarelaPago = ({
	baseUrl,
	totalPedido,
	mediosDePago,
	ReiniciaSis,
	pedido,
	subTotal,
	clienteRegis,
	setClienteRegis,
	config,
	UrlUbicaciones,
	UrlDomiciliarios,
	setCuponPrecio,
	setTipoCupon,
	checkDomi,
	setCheckDomi,
	rutaCupones,
	setVistaMovil,
	Obsequio,
	onClickObsequio,
	Impuesto,
	totalaPagar,
	setTotalaPagar,
	clienteTemporalSeleccionado,
	setClienteTemporalSeleccionado
}) => {
	const [datosFactura, setDatosFactura] = useState({
		datosPago: {},
		pedido: [],
		cliente: {}
	})

	const [importeRecibido, setImporteRecibido] = useState(0)
	const [modalPago, setModalPago] = useState(false)
	const ControlModalPago = e => setModalPago(!modalPago)
	const [funcion, setFuncion] = useState('pago')
	//const [funcion, setFuncion] = useState('cliente')
	const cookies = new Cookies()

	const [selectMedioP, setSelectMedioP] = useState({ nombre: '', estado: 'contado' })
	const [referenciaPago, setReferenciaPago] = useState('')

	const [descPersonali, setDescPersonali] = useState({ activo: false, concep: '', valor: 0 })

	const [selectDomi, setSelectDomi] = useState({ nombre: '' })
	const [selectUbica, setSelectUbica] = useState({ nombre: '' })
	const [checkFac, setCheckFac] = useState(false)
	const [informacionCupones, setInformacionCupones] = useState({ texto: '', valido: false })
	const [cuponValido, setCuponValido] = useState(null)
	const [mediosPagoPasarela, setMediosPagoPasarela] = useState([])
	const [importeAnteriorTemporal, setImporteAnteriorTemporal] = useState(0)
	const [tarifaMedios, setTarifaMedios] = useState(0)
	const [sumaMedios, setSumaMedios] = useState(0)
	const [sumaMediosTarifa, setSumaMediosTarifa] = useState(0)
	const [impuestosMedios, setImpuestosMedios] = useState(0)
	const [subtotalMedios, setSubtotalMedios] = useState(0)

	const [valorImpuestoMedios, setValorImpuestoMedios] = useState(0)
	const getSubtotalNetoPedido = () => parseFloat(totalPedido?.subtotalNeto ?? totalPedido?.subtotal ?? 0)

	const CambiaValorImporte = valor => e => {
		if (valor === 0) {
			if (mediosPagoPasarela.length > 0) {
				setImporteRecibido((valor + sumaMedios).toFixed(2) * 1)
			} else {
				setImporteRecibido(valor.toFixed(2) * 1)
			}
		} else {
			setImporteRecibido((valor + importeRecibido).toFixed(2) * 1)

		}
	}

	const CambiaValorImporteReset = valor => e => {
		if (valor === 0) {
			setImporteRecibido(valor.toFixed(2) * 1)
		} else {
			setImporteRecibido((valor + importeRecibido).toFixed(2) * 1)
		}
		setMediosPagoPasarela([])
		setValorImpuestoMedios(0)
		setSumaMedios(0)
		setImporteAnteriorTemporal(0)
	}

	const RevisasihayCurso = (pedidos) => {
		let cursos = []
		pedidos.map(item => {
			if (item.tipo === "Curso") {
				cursos.push(item.id_curso)
			}
		})
		return cursos
	}

	const ConcatenaMedios = () => {

		let cadena = ''
		mediosPagoPasarela.map(item => {
			cadena = `${cadena} ${item.medioPagoNombre},`
		})
		if (importeRecibido - subtotalMedios > 0) {
			cadena = `${cadena} Efectivo`
		}
		return cadena
	}

	const peticionPost = async () => {

		console.log('pedido', pedido)

		pedido.map(item => {
			if (item.inventario <= 0){
				alert(`El producto ${item.nombre_producto} no tiene inventario suficiente`)
			}
		})

		let cursos = RevisasihayCurso(pedido)
		const urlPedidos = baseUrl + 'pedidos/'

		let cambio = (importeRecibido - (parseFloat(totalPedido.totalEfectivo) - descPersonali.valor) - valorImpuestoMedios)
		cambio = Math.round(cambio * 100) / 100

		const fecha = moment().format("YYYY-MM-DD HH:mm:ss");
		const { cupones, impuesto_nombre, subtotal, subtotalNeto, total, valor_impuesto, totalCargas, cuponPrecio, totalEfectivo } = subTotal
		const subtotalNetoPago = subtotalNeto ?? subtotal
		let datosPago = {
			"subtotal": subtotal,
			"subtotalNeto": subtotalNetoPago,
			"taxes": mediosPagoPasarela.length > 0 ? impuestosMedios : 0,
			"totalCargas": totalCargas,
			"cargas": totalCargas,
			"porcentajeImpuesto": selectMedioP.nombre !== '' ? valor_impuesto : 0,
			"total": mediosPagoPasarela.length > 0 ? totalaPagar : totalEfectivo,
			"cupon": cuponValido,
			"descuento": cupones,
			"referencia": referenciaPago,
			"canal": 'Facturación',
			"vendedor": cookies.get('nombre'),
			"medio": mediosPagoPasarela.length > 0 ? ConcatenaMedios() : 'Efectivo',
			"estadoMedio": selectMedioP.estado,
			"electronica": checkFac ? 'true' : 'false',
			cambio: cambio,
			impuesto_nombre: mediosPagoPasarela.length > 0 ? impuesto_nombre : '',
			valor_impuesto: mediosPagoPasarela.length > 0 ? impuestosMedios : 0,
			nombreDescPersonali: descPersonali.concep !== '' && cupones > 0 ? descPersonali.concep : cupones > 0 ? 'En blanco' : '',
			valorDescPersonali: cupones,
			mediosPagoPasarela: [...mediosPagoPasarela,
			{
				"id": 1000,
				"medioPago": 1000,
				"importe": importeRecibido - sumaMedios,
				"interes": 0,
				"referencia": "",
				"tarifaPorcentaje": 0,
				"tarifa": 4,
				"idRef": 1545,
				"medioPagoNombre": "Efectivo"
			}
			],
			totalMediosdePago: sumaMedios - descPersonali.valor,
			totalFee: sumaMediosTarifa,
			porcentajeFee: tarifaMedios,
			ImpuestoMedios: impuestosMedios,
			fee: sumaMediosTarifa,
			tax: impuestosMedios
		}


		let valorPuntos = 10;
		let roll = 'Estudiante'
		let clave = Math.ceil(Math.random() * 9999999999);
		let FechaCad = moment()
		FechaCad.add(6, 'months');
		let caducidad = FechaCad.format('YYYY-MM-DD');

		let f = new FormData()

		let datos = {
			nombre: clienteRegis?.nombres,
			email: clienteRegis?.email,
			tel: clienteRegis?.telefono,
			pais: clienteRegis?.pais,
			estado: clienteRegis?.estado,
			ciudad: clienteRegis?.ciudad,
			direccion: clienteRegis?.direccion,
			zip: clienteRegis?.zipCode,
		}

		if (cursos.length == 0 && !clienteRegis) {
			datos = {
				nombre: "CLIENTE MOSTRADOR",
				email: "222222@222.com",
				tel: "222222",
				pais: "Estados Unidos",
				estado: "222222",
				ciudad: "222222",
				direccion: "222222",
				zip: "222222",
			}
		}

		

		try {

			f.append('METHOD', 'POST')
			f.append('fecha', fecha)
			f.append('total', selectMedioP.nombre !== '' ? total : totalEfectivo)
			f.append('totalStripe', parseInt(selectMedioP.nombre !== '' ? total : totalEfectivo * 100))
			f.append('datosPago', JSON.stringify(datosPago))
			f.append('cliente', JSON.stringify(datos))
			f.append('name', datos.nombre)
			f.append('email', datos.email)
			f.append('phone', datos.tel)
			f.append('pedido', JSON.stringify(pedido))

			f.append('valor_puntos_compra', valorPuntos)
			f.append('usuario', datos.email)
			f.append('pais', datos.pais)
			f.append('estado', datos.estado)
			f.append('ciudad', datos.ciudad)
			f.append('roll', roll)
			f.append('clave', clave)
			f.append('caducidad', caducidad)
			f.append('cursos', JSON.stringify(cursos))
			f.append('base_url', baseUrl)
			f.append('CANAL', 'FACTURA')

			const respuesta = await axios.post(urlPedidos, f)

			console.log('respuesta', respuesta)
			console.log('respuesta', respuesta.data.id)

			let datosFac = {
				canal: 'Facturación',
				codigo: "BLUE-" + respuesta.data.id,
				fecha,
				medio: selectMedioP.nombre !== '' ? selectMedioP.nombre : 'Efectivo',
				estado: 'activo',
				total: selectMedioP.nombre !== '' ? total : totalEfectivo,
				cambio: cambio,
				datosPago: {
					...datosPago,
					referencia: referenciaPago,
					importe: selectMedioP.nombre !== '' ? total : importeRecibido,
					medio: selectMedioP.nombre !== '' ? selectMedioP.nombre : 'Efectivo',
				},
				pedido: pedido,
				cliente: datos,

			}

			if (checkFac) {
				peticionPostFacturaE(datosFac)
			}
			setFuncion('terminado')
			setDatosFactura(datosFac)
			ReiniciaSis()
		} catch (error) {
			console.log(error)
		}
	}

	const peticionPostFacturaE = async (datosFactura) => {

		const urlFacturaE = baseUrl + 'facturaelectronica/'

		let f = new FormData()
		let body = Factura(config, datosFactura)
		f.append('body', body)
		f.append('destinatario', clienteRegis.email)
		f.append('METHOD', 'POST')

		await axios.post(urlFacturaE, f)

			.then(response => {
				console.log(response.data)
				//     errores('Limpio')
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})

	}


	//medio de pago, con cuanto pago
	const ProcedimientoPago = (medio) => {
		peticionPost()
	}
	const validarDatosVacios = registro => {
		if (registro === null) return false
		if (registro === undefined) return false
		if (registro === "") return false
		if (registro.trim().length === 0) return false

		return true;
	}

	const pagaTotal = () => {
		const { descuento, impuesto_nombre, subtotal, subtotalNeto, total, totalEfectivo } = subTotal;
		const subtotalNetoPago = parseFloat(subtotalNeto ?? subtotal)

		const cursos = RevisasihayCurso(pedido);
		const validarUsuario = clienteRegis && (
			validarDatosVacios(clienteRegis?.email) ||
			validarDatosVacios(clienteRegis?.nombres) ||
			validarDatosVacios(clienteRegis?.telefono)
		);

		if (clienteRegis && !validarUsuario) {
			return alert('Llena toda la información del cliente');
		}

		const validarDescuento = () => {
			if (descPersonali.activo && descPersonali.concep === '') {
				alert('El descuento no puede estar vacio, o deshabilite el descuento');
				return false;
			}
			return true;
		};

		const procedimientoConDomicilio = () => {
			if (validarUsuario) {
				ProcedimientoPago();
			} else {
				alert('Llena toda la información del cliente');
			}
		};

		const procesarPago = () => {
			if (checkDomi || checkFac) {
				procedimientoConDomicilio();
			} else {
				ProcedimientoPago();
			}
		};

		const verificarPedidos = () => {
			if (pedido.length === 0) {
				alert('Deben existir pedidos');
				return false;
			}
			return true;
		};

		if (mediosPagoPasarela.length > 0) {
			// Pago con medios de pagos
			if (importeRecibido >= subtotalNetoPago) {
				if (mediosPagoPasarela[0].medioPagoNombre !== "" && verificarPedidos()) {
					if (validarDescuento()) {
						procesarPago();
					}
				}
			} else {
				alert('El importe debe ser mayor o igual al total');
			}
		} else {
			// Pago con efectivo
			if (Obsequio){
				procesarPago();
			}else{
				if (importeRecibido >= subtotalNetoPago && parseFloat(totalEfectivo) >= descPersonali.valor) {
					if (verificarPedidos() && validarDescuento()) {
						procesarPago();
					}
				} else {
					alert('El importe debe ser mayor o igual al total');
				}
			}
		}
	};

	const ClienteaFinalizar = valor => {
		if (valor === 'pago') { setFuncion('pago') }
		if (valor === 'cliente') { setFuncion('cliente') }

	}

	const Factura = (config, datosFactura) => {
		return `<div style="width:327px;text-align:center;font-size:15px;font-weight:bold;margin:0px 0px;">
        <h4 style="font-size: 30px; font-weight: bold; margin: 5px 0px;"> Blue Moon Beauty SD INK</h4>
    	<span>Sede: Principal </span><br/>
        <span>https://bluemoonbeautysd.com/</span><br/>
        <hr style="border-top: 2px dashed #000;"/>
        <span>Fecha y hora: ${datosFactura.fecha}</span><br/>
        <hr style="border-top: 2px dashed #000;"/>
        <div style="text-align: left; padding: 0px 10px 0px 20px; width: 320px; height: auto; word-wrap: break-word;">
            <span>Cliente: ${datosFactura.cliente.nombre}</span><br/>
            <span>Teléfono: ${datosFactura.cliente.tel}</span><br/>
            <span>Dirección: ${datosFactura.cliente.direccion}</span><br/>
			<span>Email: ${datosFactura.cliente.email}</span><br/>
        </div>
        <hr style="border-top: 2px dashed #000;"/>

		<span>DETALLE DEL PEDIDO:</span><br/>
			${MostrarPedidos(datosFactura)}
		<hr style="border-top: 2px dashed #000;"/>

		<span>DETALLE DE VALORES:</span><br/>
		<div style="width:327px;text-align:center;font-size:15px;font-weight:bold;margin:0px 0px;">
			<span>NOMBRE IMPUESTO: Taxes</span><br/>
			<span>SUBTOTAL: $${datosFactura.datosPago.subtotal} - </span><br />
			<span>IMPUESTO: $${datosFactura.datosPago.taxes}</span><br/>
			<span>DESCUENTO: $${datosFactura.datosPago.descuento} - </span><br />
			<span>TOTAL: $${datosFactura.datosPago.total}</span><br/>
			<span>Taxes: ${currencyFormat(datosFactura.datosPago.taxes)}</span><br />
			<span>Total ${currencyFormat(datosFactura.datosPago.total)}</span><br />
		</div>
		<hr style="border-top: 2px dashed #000;"/>

		<span>DATOS DE PAGO:</span><br/>
		<div style="width:327px;text-align:center;font-size:15px;font-weight:bold;margin:0px 0px;">
			<span>MEDIO: ${datosFactura.datosPago.medio} - </span><br />
			<span>REFERENCIA: ${datosFactura.datosPago.referencia}</span><br/>
			<span>RECIBIDO: $${datosFactura.datosPago.importe} - </span><br />
			<span>CAMBIO: $${datosFactura.datosPago.importe - datosFactura.datosPago.total - valorImpuestoMedios}</span><br/>
		</div>
		<hr style="border-top: 2px dashed #000;"/>

		

	  <span>Impreso por:</span><br />
      <span>Tecnosoluciones y Software</span><br />
      <span>www.tecnosolagencia.com - (+57) 315 415 5690</span><br />
	  <hr style="border-top: 2px dashed #000;"/>
      <span>No se hacen devoluciones ni cambios de productos</span><br />
      <br />
      <span></span><br /><span></span><br />

        </div>`
	}

	const MostrarPedidos = (datosFactura) => {
		let resultado = ''
		datosFactura.pedido.map((item, index) => {
			resultado = `${resultado} 
			<div key=${index} style="width:327px;text-align:center;font-size:15px;font-weight:bold;margin:0px 0px;">
				<table responsive style="width: 100%; color: #212529;">
				<tbody>
					<tr style="width:327px; border-top: none !important; padding: 2px !important; color: #000; font-weight: bold; text-align: left;">
					<td>${item.cantidad_producto}</td>
					<td>${item.nombre_producto}</td>
					<td>$${item.precio_rebajado > 0 ? item.precio_rebajado : item.precio_producto}</td>
					<td>$${item.precio_rebajado > 0 ? item.precio_rebajado * item.cantidad_producto : item.precio_producto * item.cantidad_producto}</td>
					</tr>
				</tbody>
				</table>
				${MostrarAtributos(item)}
			</div>`
		})
		return resultado
	}

	const MostrarAtributos = (item) => {
		let inicio = `<div style="text-align: left; padding: 0px 10px 0px 20px; width: 320px; height: auto; word-wrap: break-word;"><div><span>Comb: </span>`
		let final = `</div></div><div style="text-align: left; padding: 0px 10px 0px 20px; width: 320px; height: auto; word-wrap: break-word;"><p> </p> </div>`
		let resultado = ''
		if (item.atributos.length > 0) {
			item.atributos.map((item, index) => {

				if (item.combo === "true") {
					resultado = `${resultado} <span key=${index}>(x${item.cantidad}) ${item.producto.nombre_producto}: ${item.opciones.padre}: ${item.opciones.nombre} </span>`
				} else {
					resultado = `${resultado} <span key=${index}>${item.atributo.opcion}, </span>`
				}

			})
		}
		return `${inicio}${resultado}${final}`
	}


	const validarCupon = async () => {
		try {
			if (descPersonali.concep) {
				const obtenerCupones = await axios(rutaCupones, { params: { codigoCupon: descPersonali.concep } });

				if (obtenerCupones.data) {
					const fechaActual = moment(moment().format("YYYY-MM-DD HH:mm:ss"));
					const fechaTerminacion = moment(obtenerCupones.data.fechatermino);

					const diasDiferencia = fechaTerminacion.diff(fechaActual, 'days');

					if (diasDiferencia >= 0 && obtenerCupones.data.activo === 'true') {
						setCuponPrecio(parseFloat(obtenerCupones.data.descuento))
						setTipoCupon(obtenerCupones.data.porcentaje)

						setCuponValido(descPersonali.concep)
						return setInformacionCupones({ texto: 'El cupón es valido', valido: true })
					}
					setCuponValido(null)
					return setInformacionCupones({ texto: 'El cupón no es valido', valido: false })
				} else {
					setCuponValido(null)
					return setInformacionCupones({ texto: 'El cupón no es valido', valido: false })
				}
			}
			return setInformacionCupones({ texto: '', valido: false })

		} catch (error) {
			console.log(error)
		}
	}

	const onchangeMediosPagoPasarela = (nombre, dato, i, valorImpuestos = 0, eliminar) => {
		if (eliminar) {
			console.log('aqui ok1')
			const nuevaLista = mediosPagoPasarela.filter((item) => item.id !== dato.id);
			// Actualizar el estado con la nueva lista de valores
			setMediosPagoPasarela(nuevaLista);
			let valorTotalGeneral = 0;
			let valorTotalImpuestos = 0;
			let valorTotalTax = 0;
			let valorTotalImporte = 0;

			nuevaLista.forEach(metodo => {
				metodo.interes = metodo.importe * (parseFloat(Impuesto) * 0.01);
				metodo.tarifaPorcentaje = (metodo.tarifa / 100) * metodo.importe;
				valorTotalGeneral += metodo.importe + metodo.interes + metodo.tarifaPorcentaje;

				valorTotalImpuestos += metodo.tarifaPorcentaje;
				valorTotalTax += metodo.interes;
				valorTotalImporte += metodo.importe;
			});

			valorTotalGeneral = Math.round(valorTotalGeneral * 100) / 100
			valorTotalImpuestos = Math.round(valorTotalImpuestos * 100) / 100
			valorTotalTax = Math.round(valorTotalTax * 100) / 100
			valorTotalImporte = Math.round(valorTotalImporte * 100) / 100

			setImporteRecibido((importeRecibido - sumaMedios) + valorTotalGeneral)
			setSumaMediosTarifa(valorTotalImpuestos)
			setImpuestosMedios(valorTotalTax)
			setSumaMedios(valorTotalGeneral)
			setSubtotalMedios(valorTotalImporte)
			setValorImpuestoMedios(valorTotalImpuestos + valorTotalTax)
			let precioaPagar = (getSubtotalNetoPedido() - valorTotalImporte) + valorTotalGeneral - descPersonali.valor
			precioaPagar = Math.round(precioaPagar * 100) / 100
			setTotalaPagar(precioaPagar)
		} else {
			let mediosPago = [...mediosPagoPasarela];
			mediosPago[i][nombre] = dato
			setMediosPagoPasarela(mediosPago)
			setImporteAnteriorTemporal(importeRecibido)
		}
	}

	const onChangeImporte = () => {
		let valorTotalGeneral = 0;
		let valorTotalImpuestos = 0;
		let valorTotalTax = 0;
		let valorTotalImporte = 0;

		mediosPagoPasarela.forEach(metodo => {
			metodo.interes = metodo.importe * (parseFloat(Impuesto) * 0.01);
			metodo.tarifaPorcentaje = (metodo.tarifa / 100) * metodo.importe;
			valorTotalGeneral += metodo.importe + metodo.interes + metodo.tarifaPorcentaje;
			valorTotalImpuestos += metodo.tarifaPorcentaje;
			valorTotalTax += metodo.interes;
			valorTotalImporte += metodo.importe;

		});

		valorTotalGeneral = Math.round(valorTotalGeneral * 100) / 100
		valorTotalImpuestos = Math.round(valorTotalImpuestos * 100) / 100
		valorTotalTax = Math.round(valorTotalTax * 100) / 100
		valorTotalImporte = Math.round(valorTotalImporte * 100) / 100

		setImporteRecibido((importeRecibido - importeAnteriorTemporal) + valorTotalGeneral)
		setSumaMediosTarifa(valorTotalImpuestos)
		setImpuestosMedios(valorTotalTax)
		setSumaMedios(valorTotalGeneral)
		setSubtotalMedios(valorTotalImporte)
		setValorImpuestoMedios(valorTotalImpuestos + valorTotalTax)
		let precioaPagar = (getSubtotalNetoPedido() - valorTotalImporte) + valorTotalGeneral - descPersonali.valor
		precioaPagar = Math.round(precioaPagar * 100) / 100

		setTotalaPagar(precioaPagar)
	}

	const valorAnterior = (importe) => {
		setImporteAnteriorTemporal(importe)
	}

	const handleMediosPagos = () => {
		setMediosPagoPasarela(
			[...mediosPagoPasarela, { id: null, medioPago: null, importe: 0, referencia: '', tarifa: 0, idRef: Math.floor(Math.random() * 4000) }
			])
	}

	let cambio = (importeRecibido - (parseFloat(totalPedido.totalEfectivo) - descPersonali.valor) - valorImpuestoMedios)

	let cash = importeRecibido - sumaMedios;

	cash = Math.round(cash * 100) / 100
	cambio = Math.round(cambio * 100) / 100

	const cambiarCheckFac = valor => {
		if (valor === true && clienteRegis?.nombre === undefined) {
			alert('Debe seleccionar un cliente')
			return setCheckFac(false)
		}
		setCheckFac(valor)
	}

	return (
		<React.Fragment>
			{funcion === 'cliente' ?
				<React.Fragment>
					<div>
						<RegistraClientes
							clienteRegis={clienteRegis}
							setClienteRegis={setClienteRegis}
							ClienteaFinalizar={ClienteaFinalizar}
							clienteTemporalSeleccionado={clienteTemporalSeleccionado}
							setClienteTemporalSeleccionado={setClienteTemporalSeleccionado}
							setCheckFac={setCheckFac}
						/>
					</div>
				</React.Fragment>
				: null}
			{funcion === 'pago' ?
				<React.Fragment>
					<div className="headerPasarela">
						{clienteRegis ? <h6>
							{clienteRegis?.nombres}  - {clienteRegis?.email}
						</h6> : null}
						{mediosPagoPasarela.length > 0 ?
							<h4>
								<span>Subtotal: <NumericFormat value={getSubtotalNetoPedido() - descPersonali.valor} displayType={'text'} thousandSeparator={true} prefix={'$'} /> - </span>
								<b>Total a pagar: <NumericFormat value={totalaPagar} displayType={'text'} thousandSeparator={true} prefix={'$'} />  </b>
							</h4>
							:
							<h4>
								<span>Total a pagar: <NumericFormat value={getSubtotalNetoPedido() - descPersonali.valor} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span>
							</h4>
						}

					</div>
					<div className='header-tipos-pago'>
						<div className='medios-de-pago col-md-6 col-sm-12'>
							<FontAwesomeIcon icon={faCreditCard} />
							<div className='medios-de-pago-container'>
								<span>Pago Medio de Pago: {mediosPagoPasarela.length > 0 ? <><span>Sub: </span> {Number(subtotalMedios) > 0 ? <NumericFormat value={subtotalMedios} displayType={'text'} thousandSeparator={true} prefix={'$'} /> : null}</> : null}</span>
								{mediosPagoPasarela.length > 0 ?
									<div className=' medios-de-pago-container-items'>
										<span>Total:</span> <NumericFormat value={sumaMedios - descPersonali.valor} displayType={'text'} thousandSeparator={true} prefix={'$'} />
										<span>Fee:</span> <NumericFormat value={sumaMediosTarifa} displayType={'text'} thousandSeparator={true} prefix={'$'} />
										<span>Tax:</span> <NumericFormat value={impuestosMedios} displayType={'text'} thousandSeparator={true} prefix={'$'} />
									</div>
									:
									<div className=' medios-de-pago-container-items'>
										<span>Total:</span> <NumericFormat value={totalPedido.total - descPersonali.valor} displayType={'text'} thousandSeparator={true} prefix={'$'} />
									</div>
								}
							</div>
						</div>
						<div className='pago-con-efectivo col-md-6 col-sm-12'>
							<FontAwesomeIcon icon={faMoneyBillWave} />
							<div className='medios-de-pago-container'>
								<span>Pago con Efectivo: {mediosPagoPasarela.length > 0 ? <><span>Sal: </span> <NumericFormat value={getSubtotalNetoPedido() - subtotalMedios} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </> : null} </span>
								<div className=' medios-de-pago-container-items'>


									<span>Cash:</span> <NumericFormat decimalScale={2} value={cash} displayType={'text'} thousandSeparator={true} prefix={'$'} />



									{(importeRecibido - (totalPedido.totalEfectivo - descPersonali.valor)) >= 0 && cambio >= 0 ?

										<React.Fragment>
											<b><span className="naranja">
												<FontAwesomeIcon size='1xs' icon={faMoneyBillWave} />
												<span className='mr-0'>Cambio: </span>
												<NumericFormat value={cambio} displayType={'text'} thousandSeparator={true} prefix={'$'} />
											</span></b>
										</React.Fragment>

										: null}
								</div>
							</div>
						</div>
					</div>


					<div className="CajaPasarela sombra">
						<div className="form-group">
							<div className="form-group">
								<label htmlFor="example1">Importe Recibido</label>
								<NumericFormat
									className="form-control form-control-lg"
									value={importeRecibido}
									thousandSeparator={true}
									prefix={'$'}
									decimalScale={2}
									onValueChange={(e, value) => setImporteRecibido(e.value)}
								/>
							</div>
						</div>
						<Billetes CambiaValorImporte={CambiaValorImporte} CambiaValorImporteReset={CambiaValorImporteReset} />
						<div className='row'>
							<div className='col-md-5'>
								<Domicilios
									UrlUbicaciones={UrlUbicaciones}
									UrlDomiciliarios={UrlDomiciliarios}
									selectDomi={selectDomi}
									setSelectDomi={setSelectDomi}
									selectUbica={selectUbica}
									setSelectUbica={setSelectUbica}
									checkDomi={checkDomi}
									setCheckDomi={setCheckDomi}
									clienteRegis={clienteRegis}
								/>
							</div>
							<div className='col-md-7'>
								<FacturaElectronica
									cambiarCheckFac={cambiarCheckFac}
									clienteRegis={clienteRegis}
									checkFac={checkFac}
									setCheckFac={setCheckFac}
								/>
							</div>
						</div>


						{descPersonali.activo ?
							<div className="row descPasaerla">
								<div className="col-md-6">
									<MDBInput label="Introduce tu código promocional" outline
										value={descPersonali.concep}
										onChange={e => { setDescPersonali({ ...descPersonali, concep: e.target.value }) }}
									/>
									{informacionCupones.texto ? <p className={`${informacionCupones.valido ? 'text-success' : 'text-danger'} `}>{informacionCupones.texto}</p> : null}
								</div>
								<div className="col-md-4">
									<button className="btn boton_estandar rounded-0 mb-0" type="button" onClick={validarCupon}>Validar Cupon</button>
								</div>
							</div>

							: null}

						<ModalPagoFinal
							titulo={'Medios de Pago'}
							medios={mediosDePago}
							onChange={onchangeMediosPagoPasarela}
							value={mediosPagoPasarela}
							onChangeImporte={onChangeImporte}
							valorAnterior={valorAnterior}
						/>
					</div>
					<div className="cont_botones_pasarela">
						<BotonesPos
							onClickObsequio={onClickObsequio}
							Obsequio={Obsequio}
							onClick1={handleMediosPagos}
							nombre1={'Medios de Pago'}
							onClick2={pagaTotal}
							nombre2={'Pagar'}
							atras={true}
							ClienteaFinalizar={ClienteaFinalizar}
							onClickDes={e => { setDescPersonali({ activo: !descPersonali.activo, concep: '', valor: 0 }) }}
						/>
					</div>

					<br />
				</React.Fragment>
				: null}
			{funcion === 'terminado' ?
				<div>
					<center>
						<h4 className="tituloModal">Transacción Realizada Exitosamente</h4>
					</center>
					<div className="container contenedor_tique">
						<Tiquete
							datosFactura={datosFactura}
							config={config}
							selectDomi={selectDomi}
						/>
					</div>
					<div className='d-flex d-sm-flex d-md-none'>
						<div className="boton-ver-pedido-vista-movil w-100">
							<button
								onClick={() => { setVistaMovil('ver') }}
								className="btn boton_estandar-subtotal">
								Seguir Comprando
							</button>
						</div>
					</div>
				</div>

				: null}
		</React.Fragment>
	)
}



export default PasarelaPago
